"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tlj = _interopRequireDefault(require("./components/tlj.vue"));
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TljPromotionposition',
  components: {
    tlj: _tlj.default
  }
};